// Where the portal goes once the patient has signed in: the page a link asked
// for (`?next=/chat`, the "a secure message is waiting" alert, blhWebServer
// ADR 0018 §7), when it is one of the portal's own pages; home otherwise.
//
// Only a page of this app, from a fixed list: a `next` that could name any path
// or another site is an open redirect, which hands a fresh session's first page
// to whoever wrote the link.

const OWN_PAGES = new Set(["/chat", "/appointments", "/forms", "/consents", "/files", "/billing", "/account", "/journal"]);
const HOME = "../";

export function signInDestination(search) {
  let next = null;
  try {
    next = new URLSearchParams(search || "").get("next");
  } catch {
    next = null;
  }
  return next && OWN_PAGES.has(next) ? next : HOME;
}
